import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, option_type, string_type, class_type, int32_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Result_isOk, ResultComputationExpression_ResultBuilder__Zero, ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Return_1505, ResultComputationExpression_ResultBuilder__Combine_71B5E353, Result_sequence, ResultComputationExpression_ResultBuilder__Bind_764BA1D3, ResultComputationExpression_ResultBuilder__Delay_1505, ResultComputationExpression_ResultBuilder__Run_FCFD9EF } from "../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { validateNotEmptyGuid } from "../../fable_modules/Webbler.Models.1.6.0/Validation.fs.js";
import { ErrorMessage } from "../ErrorMessage.js";
import { length, ofArray, map, choose } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { StudyValidators_validateStringNotNullOrWhiteSpace } from "./Study.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.3/Result.js";

export class RevisionViewModel extends Record {
    constructor(revisionNumber, studyId, uiDataFileChecksum, centerlineLumenUploadPath, centerlineWallUploadPath, axialLumenUploadPath, axialWallUploadPath, axialVisceralUploadPath, cprCenterlineUploadPath, stretchedCprControlPointsUploadPath) {
        super();
        this.revisionNumber = (revisionNumber | 0);
        this.studyId = studyId;
        this.uiDataFileChecksum = uiDataFileChecksum;
        this.centerlineLumenUploadPath = centerlineLumenUploadPath;
        this.centerlineWallUploadPath = centerlineWallUploadPath;
        this.axialLumenUploadPath = axialLumenUploadPath;
        this.axialWallUploadPath = axialWallUploadPath;
        this.axialVisceralUploadPath = axialVisceralUploadPath;
        this.cprCenterlineUploadPath = cprCenterlineUploadPath;
        this.stretchedCprControlPointsUploadPath = stretchedCprControlPointsUploadPath;
    }
}

export function RevisionViewModel_$reflection() {
    return record_type("RAWMap.Models.View.RevisionViewModel", [], RevisionViewModel, () => [["revisionNumber", int32_type], ["studyId", class_type("System.Guid")], ["uiDataFileChecksum", option_type(string_type)], ["centerlineLumenUploadPath", option_type(string_type)], ["centerlineWallUploadPath", option_type(string_type)], ["axialLumenUploadPath", option_type(string_type)], ["axialWallUploadPath", option_type(string_type)], ["axialVisceralUploadPath", option_type(string_type)], ["cprCenterlineUploadPath", option_type(string_type)], ["stretchedCprControlPointsUploadPath", option_type(string_type)]]);
}

export function RevisionViewModel_validate_Z7FB916AD(vm) {
    return ResultComputationExpression_ResultBuilder__Run_FCFD9EF(ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Delay_1505(ResultComputationExpression_result, () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, validateNotEmptyGuid(new ErrorMessage(6, ["StudyId", "not be empty Guid"]), vm.studyId), () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, Result_sequence(choose((x) => x, map((tupledArg) => map_1((fieldValue) => StudyValidators_validateStringNotNullOrWhiteSpace(tupledArg[1], fieldValue), tupledArg[0]), ofArray([[vm.centerlineLumenUploadPath, "CenterlineLumenUploadPath"], [vm.centerlineWallUploadPath, "CenterlineWallUploadPath"], [vm.axialLumenUploadPath, "AxialLumenUploadPath"], [vm.axialWallUploadPath, "AxialWallUploadPath"], [vm.axialVisceralUploadPath, "AxialVisceralUploadPath"], [vm.cprCenterlineUploadPath, "CprCenterlineUploadPath"], [vm.stretchedCprControlPointsUploadPath, "StretchedCprControlPointsUploadPath"]])))), (_arg_1) => ResultComputationExpression_ResultBuilder__Combine_71B5E353(ResultComputationExpression_result, (length(_arg_1) === 0) ? ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, new FSharpResult$2(1, [new ErrorMessage(6, ["UploadPaths", "not be null (at least one)"])]), () => ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, undefined)) : ResultComputationExpression_ResultBuilder__Zero(ResultComputationExpression_result), ResultComputationExpression_ResultBuilder__Delay_1505(ResultComputationExpression_result, () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, (vm.revisionNumber > 0) ? (new FSharpResult$2(0, [undefined])) : (new FSharpResult$2(1, [new ErrorMessage(6, ["RevisionNumber", "not be less than or equal to 0"])])), () => ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, vm))))))));
}

export function RevisionViewModel_isValid_Z7FB916AD(vm) {
    return Result_isOk(RevisionViewModel_validate_Z7FB916AD(vm));
}

export function RevisionViewModel_getStudyId_Z7FB916AD(vm) {
    return vm.studyId;
}

export function RevisionViewModel_getPrimaryId_Z7FB916AD(vm) {
    return vm.revisionNumber;
}

export function RevisionViewModel_get_primaryIdName() {
    return "RevisionNumber";
}

export function RevisionViewModel_get_description() {
    return "Revision";
}

export function RevisionViewModel_desc_Z7FB916AD(_arg) {
    return RevisionViewModel_get_description();
}

export function RevisionViewModel_revisionNameByNumber_Z524259A4(revisionNumber) {
    if (revisionNumber <= 0) {
        return "Baseline";
    }
    else {
        return `Rev ${revisionNumber}`;
    }
}

export function RevisionViewModel_get_revisionNumberFromOption() {
    return (_arg) => ((_arg != null) ? _arg.revisionNumber : 0);
}

